var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"aria-label":_vm.ariaLabel,"tabindex":_vm.tabindex},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s('はじめから質問しなおす')),_vm._t("icon",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }